import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const OkruhPp = {
	name: NAME,
	apiProvider,
	router,
};
